import { render } from "./ConfigOptions.vue?vue&type=template&id=9dc6d7ec"
import script from "./ConfigOptions.vue?vue&type=script&lang=js"
export * from "./ConfigOptions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__